import {inject, Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {Observable} from 'rxjs';
import {ConfirmDialogComponent, ConfirmDialogData} from "../../components/confirm-dialog/confirm-dialog.component";

@Injectable({
    providedIn: 'root'
})
export class ConfirmDialogService {
    private dialog = inject(MatDialog);


    confirm(data: ConfirmDialogData): Observable<boolean> {
        const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '600px',
            data: data
        });

        return dialogRef.afterClosed();
    }
}
